import { ReactNode, useId, useState } from "react";

import { t } from "@impero-com/common/utils/i18n";
import {
    PageColumns,
    PageLayout,
    PageNavMenuPanel,
    PageNavMenuToggle,
} from "@impero-com/ui";

import { ApplicationHeaderProps } from "../applicationBar/applicationHeader";
import { OrgApplicationBarHeader } from "../applicationBar/OrgApplicationBarHeader";

interface PageNavMenuLayoutProps extends ApplicationHeaderProps {
    menu: ReactNode;
    /**
     * The `PageNavMenuMain`. Render loading and error states inside it to keep
     * the header and menu on screen.
     */
    children: ReactNode;
}

/**
 * A page with a full-width header and a page navigation menu its toggle hides.
 */
export function PageNavMenuLayout({
    title,
    routerLinks,
    menu,
    children,
}: PageNavMenuLayoutProps) {
    const [expanded, setExpanded] = useState(true);
    const menuId = useId();

    return (
        <PageLayout fullHeight>
            <OrgApplicationBarHeader
                title={title}
                routerLinks={routerLinks}
                leading={
                    <PageNavMenuToggle
                        expanded={expanded}
                        onExpandedChange={setExpanded}
                        label={
                            expanded
                                ? t("PageNavMenu_HidePages")
                                : t("PageNavMenu_ShowPages")
                        }
                        aria-controls={menuId}
                    />
                }
            />
            <PageColumns>
                <PageNavMenuPanel id={menuId} collapsed={!expanded}>
                    {menu}
                </PageNavMenuPanel>
                {children}
            </PageColumns>
        </PageLayout>
    );
}
